<template>
  <b-card
    title="Reaktife Giren Cihazlar"
    class="border border-secondary"
  >
    <b-table-lite
      hover
      class="yeni"
      :items="items"
    />
    <br>

  </b-card>

</template>

<script>

import { BTableLite, BCard } from 'bootstrap-vue'

export default {
  components: {

    BTableLite,
    BCard,
  },
  data() {
    return {
      items: [
        {
          Cihaz_Seri_no: 0, Sektor_Adı: '--', adres: '--', Reaktif_Bedeli: '0',
        },

      ],
    }
  },
}
</script>
<style>
.yeni{
  background-color:bisque;
}
</style>
